import { render, staticRenderFns } from "./MyDouData.vue?vue&type=template&id=677584d7&scoped=true"
import script from "./MyDouData.vue?vue&type=script&lang=js"
export * from "./MyDouData.vue?vue&type=script&lang=js"
import style0 from "./MyDouData.vue?vue&type=style&index=0&id=677584d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677584d7",
  null
  
)

export default component.exports